import axios from 'axios'
import {Response} from '@/domain/Common'
import moment, {Moment} from 'moment'
import env from '@//util/Env'

export class PMStrategyPerformanceService {
  public static get(pms: string, startValue: number, deposit: number):
    Promise<PMStrategyPerformance> {
    return axios
      .get<Response<PMStrategyPerformanceResponse>>(
        `${env.ApiUrl}/public/portfolio/${pms}/chart?start=${startValue}&deposit=${deposit}`,
      )
      .then((res) => {
        return {
          chartData: res
            .data
            .result
            .chartData
            .map((d) => {
              return {
                date: moment(d.date),
                value: parseInt(d.value, 10),
                bookValue: parseInt(d.bookValue, 10),
              } as PerformanceData
            }),
        } as PMStrategyPerformance
      })
  }
}

export interface PMStrategyPerformanceResponse {
  chartData: PerformanceDataResponse[]
}

export interface PerformanceDataResponse {
  date: string
  value: string
  bookValue: string
}

export interface PMStrategyPerformance {
  chartData: PerformanceData[]
}

export interface PerformanceData {
  date: Moment
  value: number
  bookValue: number
}
